import { render, staticRenderFns } from "./CtaExtractorPhilipsAvent.vue?vue&type=template&id=979490fc"
import script from "./CtaExtractorPhilipsAvent.vue?vue&type=script&lang=js"
export * from "./CtaExtractorPhilipsAvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports